export const MAJOR_STATES = {
  home: "home",
  login: "login",
  logout: "logout"
};
